<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" v-loading="loading" :model="formData" :rules="rules" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="领用日期" prop="outboundDate">
              <el-date-picker v-model="formData.outboundDate" type="date" value-format="yyyy-MM-dd"
                placeholder="请选择领用日期" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物料名称" prop="materialSpecId">
              <el-select v-model="formData.materialSpecId" filterable clearable placeholder="请选择物料名称">
                <el-option v-for="item of specList" :key="item.specId" :label="item.specName"
                  :value="item.specId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产日期及批号" prop="productionDateBatchNo">
              <el-input v-model.trim="formData.productionDateBatchNo" placeholder="请输入生产日期及批号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产厂家" prop="manufacturerId">
              <el-select v-model="formData.manufacturerId" filterable clearable placeholder="请选择生产厂家">
                <el-option v-for="item of supplierList" :key="item.materialsId" :label="item.materialsName"
                  :value="item.materialsId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保质期" prop="shelfLife">
              <el-input v-model.trim="formData.shelfLife" placeholder="请输入保质期" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到货日期" prop="arrivalDate">
              <el-date-picker v-model="formData.arrivalDate" type="date" value-format="yyyy-MM-dd"
                placeholder="请选择到货日期" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出库数量" prop="outboundQuantity">
              <el-input v-model.trim="formData.outboundQuantity" placeholder="请输入出库数量" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出库原因" prop="outboundReason">
              <el-input v-model.trim="formData.outboundReason" placeholder="请输入出库原因" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="领用人" prop="receiverUserId">
              <el-select v-model="formData.receiverUserId" filterable clearable placeholder="请选择领用人">
                <el-option v-for="item of userList" :key="item.userId" :label="item.userName"
                  :value="item.userId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model.trim="formData.remark" type="textarea" :rows="3" placeholder="请输入备注" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :loading="submitting" :disabled="loading || loadFailed" @click="submit" class="global-button">保存</el-button>
          <el-button v-if="loadFailed" @click="loadData" class="global-button">重新加载</el-button>
          <el-button :disabled="submitting" @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'MaterialOutboundAdd',
  data() {
    const validateQuantity = (rule, value, callback) => {
      if (!/^\d+(\.\d+)?$/.test(value) || !Number.isFinite(Number(value)) || Number(value) <= 0) {
        callback(new Error('出库数量必须为大于0的数字'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      loadFailed: false,
      submitting: false,
      specList: [],
      supplierList: [],
      userList: [],
      formData: {
        outboundId: '', // 原辅料出库ID
        outboundDate: '', // 领用日期
        materialSpecId: '', // 物料名称
        productionDateBatchNo: '', // 生产日期及批号
        manufacturerId: '', // 生产厂家
        shelfLife: '', // 保质期
        arrivalDate: '', // 到货日期
        outboundQuantity: '', // 出库数量
        outboundReason: '', // 出库原因
        receiverUserId: '', // 领用人
        remark: '' // 备注
      },
      rules: {
        outboundDate: [{ required: true, message: '请选择领用日期', trigger: 'change' }],
        materialSpecId: [{ required: true, message: '请选择物料名称', trigger: 'change' }],
        manufacturerId: [{ required: true, message: '请选择生产厂家', trigger: 'change' }],
        outboundQuantity: [{ required: true, validator: validateQuantity, trigger: 'blur' }],
        receiverUserId: [{ required: true, message: '请选择领用人', trigger: 'change' }]
      }
    }
  },
  computed: {
    outboundId() {
      return this.$route.query.outboundId
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.loadFailed = false
      const requests = [this.loadSpecList(), this.loadSupplierList(), this.loadUserList()]
      if (this.outboundId) {
        requests.push(this.loadDetails())
      }
      return Promise.all(requests).catch(() => {
        this.loadFailed = true
      }).finally(() => {
        this.loading = false
      })
    },
    loadSpecList() {
      return this.$axios.get(this.$apis.grainSpecifications.selectYxOilSpecByList).then(res => {
        this.specList = res.list
      })
    },
    loadSupplierList() {
      return this.$axios.get(this.$apis.rawMaterialSupplier.selectPaRawMaterialsByList).then(res => {
        this.supplierList = res.list
      })
    },
    loadUserList() {
      return this.$axios.get(this.$apis.system.selectSysUserByPage).then(res => {
        this.userList = res.list
      })
    },
    loadDetails() {
      return this.$axios.get(this.$apis.prodManage.selectScMaterialOutboundById, {
        params: { outboundId: this.outboundId }
      }).then(res => {
        Object.keys(this.formData).forEach(key => {
          this.formData[key] = res[key] == null ? '' : res[key]
        })
        this.formData.outboundDate = res.outboundDate ? dayjs(res.outboundDate).format('YYYY-MM-DD') : ''
        this.formData.arrivalDate = res.arrivalDate ? dayjs(res.arrivalDate).format('YYYY-MM-DD') : ''
      })
    },
    submit() {
      if (this.loading || this.loadFailed || this.submitting) {
        return
      }
      this.$refs.formData.validate(valid => {
        if (!valid || this.submitting) {
          return
        }
        this.submitting = true
        let url = this.$apis.prodManage.insertScMaterialOutbound
        if (this.outboundId) {
          url = this.$apis.prodManage.updateScMaterialOutbound
        }
        this.$axios.post(url, {
          ...this.formData,
          outboundId: this.outboundId,
          arrivalDate: this.formData.arrivalDate || null
        }).then(() => {
          this.$router.back()
        }).catch(() => {
          // 请求错误由全局拦截器提示，保留表单供修改后重试。
        }).finally(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-select,
.el-input,
.el-date-editor,
.el-textarea {
  width: 95%;
}
</style>
